function setupHome(root = document) {
  root.querySelectorAll('[data-pfy-home-build]').forEach(link => {
    if (link.dataset.pfyBound) return;
    link.dataset.pfyBound = 'true';
    link.addEventListener('click', async event => {
      const target = document.getElementById('pfy-build');
      if (!target) return;
      event.preventDefault();
      const menu = link.closest('details');
      if (menu) menu.open = false;
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      await customElements.whenDefined('pfy-plate-builder');
      target.querySelector('[name="registration"]')?.focus({preventScroll:true});
    });
  });
  root.querySelectorAll('.pfy-mobile-menu').forEach(menu => {
    if (menu.dataset.pfyBound) return;
    menu.dataset.pfyBound = 'true';
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {menu.open = false;}));
  });
}
setupHome();
document.addEventListener('shopify:section:load', event => setupHome(event.target));
document.addEventListener('click', event => {
  document.querySelectorAll('.pfy-mobile-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
